import { ColorTokensT } from "./types"
import * as colorScale from "./color-scale.json"

const colors: ColorTokensT = colorScale["default"]

export default colors
